import {LoadingStatus} from "../../../../../models/FormLoadingStatus";

const {
  LOADING,
  LOADED,
  TIME_OUT,
  NET_ERROR,
  ERROR
} = LoadingStatus;

export class StageRecapLoadingStatus {
  promotionHandling: LoadingStatus = LoadingStatus.LOADING;
  gettingStageData: LoadingStatus = LoadingStatus.LOADING;
}
